import CustomLink from '../../../components/shared/custom-link';
import Button from '../../../components/shared/custom-btn';
import CustomInput from '../../../components/shared/custom-input';
import React from 'react';

const LoginForm = ({ handleSubmit, formData, handleChange, errors, isSubmitting }) => {
    return (
        <form onSubmit={handleSubmit} className="space-y-3">
            <CustomInput
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                inputStyle="border border-border !py-2 bg-white rounded-lg"
                labelStyle="text-sm"
                placeholder="your@email.com"
                error={errors.email}
            />

            <div>
                <CustomInput
                    label="Password"
                    name="password"
                    type="password"
                    value={formData.password}
                    onChange={handleChange}
                    inputStyle="border border-border !py-2 bg-white rounded-lg"
                    labelStyle="text-sm"
                    placeholder="••••••••"
                    error={errors.password}
                />

                <div className='flex items-center flex-wrap justify-between w-full mt-2'>
                    <div className='flex items-center gap-2 text-sm'>
                        <input
                            type="checkbox"
                            className='h-4 w-4'
                            name="rememberMe"
                            id="rememberMe"
                            checked={formData.rememberMe}
                            onChange={handleChange}
                        />
                        <label htmlFor="rememberMe" className="cursor-pointer">Remember me</label>
                    </div>
                    <CustomLink to='/forgot-password' className={'text-blue-700 hover:underline text-sm'}>
                        Forgot Password?
                    </CustomLink>
                </div>
            </div>

            {errors.apiError && (
                <p className="text-red-500 text-sm text-center">{errors.apiError}</p>
            )}

            <Button
                type="submit"
                label="Log In"
                loading={isSubmitting}
                disabled={isSubmitting}
                loadingLabel="Logging in..."
                className="w-full bg-blue-800 mt-5 text-white font-medium py-2 px-4 rounded-lg"
            />

            <p className="text-center text-gray-600 ">
                Don’t have an account?{' '}
                <CustomLink to="/sign-up" className="text-blue-600 hover:underline">
                    Sign up
                </CustomLink>
            </p>
        </form>
    );
};

export default LoginForm;